import {formatWith} from './delphiFormat.js'

/**
 * Cell formatting shared by the Grid view and the Report view.
 *
 * A column's `format` is FrameTracker's DisplayFormat (see delphiFormat.js);
 * without one a column prints by `type` exactly as before the audit, so a
 * report that declares no formats looks the same as it did.
 */

export const NUMERIC_TYPES = ['money', 'price', 'int', 'days', 'number', 'float', 'percent']

export function money(value) {
    return (parseFloat(value) || 0).toLocaleString('en-US', {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
    })
}

// Printed '#,0.0000': rptPoList's unit prices carry up to four places.
export function price(value) {
    return (parseFloat(value) || 0).toLocaleString('en-US', {
        minimumFractionDigits: 4, maximumFractionDigits: 4,
    })
}

/** Today's rule by type, for a column with no format. */
export function formatByType(value, type) {
    if (value === null || value === undefined) return ''
    if (type === 'money') return money(value)
    if (type === 'price') return price(value)
    // Trandate is a datetime in FrameTracker but the report prints a date.
    if (type === 'date') return String(value).slice(0, 10)
    if (type === 'days') return Number(value) === -1 ? '' : value
    return value
}

/**
 * A detail cell: blank for zero where FrameTracker's BlankWhenZero is set,
 * then the column's Delphi DisplayFormat, else the rule by type.
 */
export function formatCell(value, col) {
    const column = col || {}
    if (value === null || value === undefined) return ''
    if (column.blankWhenZero && value !== '' && Number(value) === 0) return ''
    if (column.format) return formatWith(column.format, value, column.type === 'date' || column.type === 'datetime')
    return formatByType(value, column.type)
}

export function alignFor(col) {
    if (!col) return ''
    return NUMERIC_TYPES.includes(col.type) ? 'text-right' : ''
}
